import useBCAResource from "./useBCAResource";
import useQuery from "./useQuery";

export default function useBCALogic(id){
    
    const resources = useBCAResource({ id,})
    const exportExcel = useQuery({id});
    


    return {
        ...resources,
        ...exportExcel
    } 
}